import { render, staticRenderFns } from "./upServe.vue?vue&type=template&id=67636e3a&scoped=true&"
import script from "./upServe.vue?vue&type=script&lang=js&"
export * from "./upServe.vue?vue&type=script&lang=js&"
import style0 from "./upServe.vue?vue&type=style&index=0&id=67636e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67636e3a",
  null
  
)

export default component.exports